<script setup lang="ts">
import { cn } from '../ui-utils.ts';
import { AccordionHeader, AccordionTrigger, type AccordionTriggerProps, useForwardProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<AccordionTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;
  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <AccordionHeader class="flex items-center">
    <AccordionTrigger
      v-bind="forwardedProps"
      :class="
        cn(
          'flex flex-1 items-center justify-between p-3 text-[10px] font-semibold text-slate-500 transition-all hover:text-slate-700 [&[data-state=open]>i]:rotate-180',
          props.class,
        )
      "
    >
      <span class="flex items-center gap-1.5"><slot /></span>
      <i class="fa-solid fa-chevron-down text-[9px] transition-transform duration-200"></i>
    </AccordionTrigger>
    <slot name="action" />
  </AccordionHeader>
</template>
